import { type IMicrofrontendManifest } from '@cian/mf-registry/shared';
import { HttpTimeoutError } from '@cian/peperrors';

import { createAsyncThunk } from '@reduxjs/toolkit';

import { ASYNC_STATUS } from '@/packages/typesafe-result';

import { fetchUndergroundMapMicrofrontendSafe } from '../../../services/fetchUndergroundMapMicrofrontendSafe';
import { type TThunkApi } from '../../types';

export const loadUndergroundMapManifest = createAsyncThunk<
  {
    manifest: IMicrofrontendManifest;
  },
  void,
  TThunkApi
>(
  'undergroundMap/manifest',
  async (_, { extra: ctx, rejectWithValue }) => {
    const result = await fetchUndergroundMapMicrofrontendSafe(ctx, {});

    if (result.isErr()) {
      ctx.logger[result.isErrAnd(HttpTimeoutError.is) ? 'warning' : 'error'](result.Err);
    }

    return result.unwrapOrElse(rejectWithValue);
  },
  {
    condition: (_, api) => {
      const state = api.getState();

      return state.undergroundMap.status !== ASYNC_STATUS.PENDING;
    },
  },
);
